import borders from "theme/base/borders";
import pxToRem from "theme/base/pxToRem";
import typography from "theme/base/typography";
import colors from "theme/theme-light/colors";
const styledAutocomplete = {
  transition: "background-color 5000s ease-in-out 0s",
  WebkitTextFillColor: colors.text.textPrimary,
};

const inputOutlined = {
  styleOverrides: {
    root: {
      backgroundColor: colors.background.bgPrimary,
      fontSize: typography.size.md_16,
      borderRadius: borders.borderRadius.lg_8,
      color: colors.text.textPrimary,
      lineHeight: pxToRem(24) /* 150% */,
      letterSpacing: pxToRem(-0.16),
      height: pxToRem(58),
      borderColor: colors.stroke.strokeDefault,

      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: "1.5px solid" + colors.stroke.strokeMenu,
      },
      "&.Mui-focused": {
        "& .MuiOutlinedInput-notchedOutline": {
          border: "1.5px solid" + colors.stroke.strokeMenu,
        },
      },
    },
    "&.Mui-error": {
      border: "1.5px solid" + colors.stroke.strokeBrand,
    },
    input: {
      color: colors.text.textPrimary,
      backgroundColor: colors.background.bgPrimary,
      "&:-webkit-autofill": styledAutocomplete,
      "&:-webkit-autofill:hover": styledAutocomplete,
      "&:-webkit-autofill:focus": styledAutocomplete,
      "&:-webkit-autofill:active": styledAutocomplete,
    },
    sizeSmall: {
      fontSize: typography.size.xs_12,
      height: "40px",
    },
  },
};

export default inputOutlined;
